var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStatistics(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4256_2217)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.7755 20.4082H1.22449C0.548245 20.4082 0 20.9564 0 21.6327C0 22.3089 0.548245 22.8572 1.22449 22.8572H22.7755C23.4518 22.8572 24 22.3089 24 21.6327C24 20.9564 23.4518 20.4082 22.7755 20.4082Z",
    fill: "#00263A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.48938 18.6122H6.32611C6.75444 18.6122 7.10162 18.2651 7.10162 17.8367V7.22448C7.10162 6.79616 6.75444 6.44897 6.32611 6.44897H2.48938C2.06105 6.44897 1.71387 6.79616 1.71387 7.22448V17.8367C1.71387 18.2651 2.06105 18.6122 2.48938 18.6122Z",
    fill: "#00263A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.0812 18.6122H13.9179C14.3462 18.6122 14.6934 18.265 14.6934 17.8367V1.91833C14.6934 1.49001 14.3462 1.14282 13.9179 1.14282H10.0812C9.65285 1.14282 9.30566 1.49001 9.30566 1.91833V17.8367C9.30566 18.265 9.65285 18.6122 10.0812 18.6122Z",
    fill: "#00263A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.6739 18.6122H21.5107C21.939 18.6122 22.2862 18.265 22.2862 17.8367V9.26526C22.2862 8.83693 21.939 8.48975 21.5107 8.48975H17.6739C17.2456 8.48975 16.8984 8.83693 16.8984 9.26526V17.8367C16.8984 18.265 17.2456 18.6122 17.6739 18.6122Z",
    fill: "#00263A"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4256_2217"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStatistics);
export default __webpack_public_path__ + "static/media/statistics.24a1ad8e1b255196bf40ea05fd40148a.svg";
export { ForwardRef as ReactComponent };